define('modules/navigation/nav_item_collection',[
  'backbone',
  './nav_item_model'
], function (Backbone, NavItem) {
  'use strict';
  var NavigationCollection = Backbone.Collection.extend({
    model: NavItem,
    initialize: function (models, options) {

    }
  });

  return NavigationCollection;
});
